// @flow
import * as React from 'react';

import Slider from './slider';
import Button from '../button';
import settings from '../settings';

import cs from './styles.pcss';
import t from './locale';

export default function Features(): React.Node {
  return (
    <div className={cs.reviews}>
      <h2 className={cs.title}>{t('title')}</h2>
      <Slider />
      <Button
        color="white"
        className={cs.tryButton}
        withArrow
        href={settings.signIn}
        area="reviews"
      >
        {t('buttonText')}
      </Button>
    </div>
  );
}
